import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { KYMW7402Model } from "../kymw7402.model";
import { RememberGoodsInfoModel } from "../vo/remember-goods-info.model";

/**
 * 忘れず注文商品情報更新(企画確定用)
 * 
 */
@Injectable()
export class UpdateRememberGoodsInfoForFixedService extends PlessJsonResponderSub<any> {

  private model: KYMW7402Model;
  private vo: RememberGoodsInfoModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   * 
   */
  private getBody() {
    return new PlessRequest({
      update: {
        RememberGoodsInfo: {
          parameter: {
            RememberGoodsId: this.vo.rememberGoodsId,
            RememberGoodsStatus: this.vo.rememberGoodsStatus,
            ItemCode: this.vo.itemCode,
            OrderReceptionEndCatalog: this.vo.orderReceptionEndCatalog,
            DeliveryEndCatalog: this.vo.deliveryEndCatalog,
          },
          combination:  this.vo.detailInfoList.map( detail => ({
            parameter: {
              ApplicableStartCatalog: detail.applicableStartCatalog,
              ApplicableEndCatalog: detail.applicableEndCatalog,
              PauseDelivery: detail.pauseDelivery,
              DiscountType: detail.discountType,
              DiscountUnitPrice: detail.discountUnitPrice,
              DiscountRate: detail.discountRate,
              DiscountPrice: detail.discountPrice,
              RememberGoodsName: detail.rememberGoodsName,
              RememberGoodsNameKana: detail.rememberGoodsNameKana,
              RememberStandardName: detail.rememberStandardName,
              RememberStandardNameKana: detail.rememberStandardNameKana
            }
          }))
        }
      }
    })
  }

  /**
   * API呼び出し
   * 
   * @param model 
   * @param vo 
   * @param successFunc 
   */
  execute(model: KYMW7402Model, vo: RememberGoodsInfoModel, successFunc: Function = () => {}) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('updateRememberGoodsInfoForFixed', this.getBody());
  }

  /**
   * API通信成功時の処理
   * @param data 
   */
  success(data: any): void {
    this.successFunc();
  }
}